<template>
  <v-container id="city-list">
    <v-row v-if="!isAT">
      <template>
        <v-col md="2">
          <span class="filter">Ordenar por:</span>
        </v-col>

        <v-col md="1" @click="changeOrder('nome')">
          <span class="filter"> A/Z </span>
        </v-col>

        <v-col md="1" @click="changeOrder('pontos')">
          <span class="filter"> Pontos </span>
        </v-col>

        <v-col v-if="!isSala" md="1" @click="changeOrder('totalMedalhas')">
          <span class="filter"> Medalhas </span>
        </v-col>
      </template>
      <v-col md="3" offset-md="1" class="text-right">
        <!-- <app-modal-insert-cut-attendance
          v-if="isAdmin"
          @save="loadCities"
        ></app-modal-insert-cut-attendance> -->
      </v-col>

      <v-col md="3" class="text-right">
        <v-btn
          v-if="
            (isFullAdmin ||
              (config.cadastroEmLote && groupsConfig.cadastroEmLote)) &&
            isNA &&
            !isSala
          "
          @click="cadastrarEmLote()"
        >
          Cadastrar em lote
        </v-btn>
        <app-modal-insert-city
          v-if="(isAdmin || isSPFespEspecial) && !isNA"
          @save="loadCities"
        ></app-modal-insert-city>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <span class="filter">Filtrar por:</span>
      </v-col>
    </v-row>

    <v-row>
      <v-col md="2" v-if="!isSala && !isAT && projects.length > 1">
        <app-project-combobox
          :filter="filtro"
          @projects="setProjects"
          @changeProject="filterCities()"
        ></app-project-combobox>
      </v-col>

      <v-col md="2">
        <v-text-field
          label="Município"
          name="nome"
          type="text"
          v-model="filtro.nome"
          @input="filterCities()"
          clearable
        ></v-text-field>
      </v-col>
      <v-col md="2">
        <app-status-combobox
          :filter="filtro"
          @onChange="filterCities()"
        ></app-status-combobox>
      </v-col>
      <v-col md="1" v-if="$store.state.uf === 'MA' && !isSala">
        <combobox-Pacote
          :filter="filtro"
          @onChange="filterCities()"
        ></combobox-Pacote>
      </v-col>
      <v-col md="2">
        <combobox-unidade-regional
          :filter="filtro"
          @onChange="filterCities()"
        ></combobox-unidade-regional>
      </v-col>
      <v-col md="2" v-if="!isSala && !isAT">
        <combobox-Temas
          :filter="filtro"
          @teste="loadMunicipiosByTema()"
        ></combobox-Temas>
      </v-col>
      <v-col md="3">
        <consultores-combobox
          :filter="filtro"
          :consultores="consultores"
          @onChange="filterCities()"
        >
        </consultores-combobox>
      </v-col>
    </v-row>

    <v-row>
      <v-col
        md="4"
        v-for="city in paginator(cityList)"
        v-bind:key="city.municipioId"
      >
        <v-card
          class="elevation-12"
          color="primary"
          :to="'/cidade/' + city.municipioId"
        >
          <!-- img CIDADE EM BASE64 -->
          <v-img
            v-if="!isSala"
            style="height: 176px"
            class="white--text align-end"
            v-bind:src="
              city.imagemMunicipioBlob
                ? `data:image/jpeg;base64,${city.imagemMunicipioBlob}`
                : DEFAULT_BASE_64_IMG
            "
          >
            <v-card-title>{{ city.nome }}</v-card-title>
          </v-img>
          <v-img
            v-if="isSala"
            src="../../../../public/assets/img/img_sala.png"
            width="100%"
            class="black--text align-end"
          >
            <v-card-title v-if="isSala"
              ><b>{{ city.nome }}</b></v-card-title
            >
          </v-img>
          <v-card-text
            v-if="
              isFullAdmin ||
              (config.visualizarPontosMedalha &&
                groupsConfig.visualizarPontosMedalha)
            "
          >
            <v-row>
              <v-col sm="1">
                <v-icon color="white"> mdi-chart-bar </v-icon>
              </v-col>
              <v-col sm="3">
                <span class="city-card-text" v-if="city.pontos">
                  {{ city.pontos }}
                </span>
                <span class="city-card-text" v-if="!city.pontos"> 0 </span>
              </v-col>
              <v-col sm="1">
                <v-icon color="white"> mdi-medal </v-icon>
              </v-col>
              <v-col sm="2">
                <span class="city-card-text" v-if="city.totalMedalhas">
                  {{ city.totalMedalhas }}
                </span>
                <span class="city-card-text" v-if="!city.totalMedalhas">
                  0
                </span>
              </v-col>
              <v-col>
                <span class="city-card-text" v-if="!filtro.temaId">
                  {{ city.projeto.nome }}
                </span>
                <span class="city-card-text" v-else>
                  {{ city.nomeProjeto }}
                </span>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-pagination
          v-model="page"
          :total-visible="7"
          :length="Math.ceil(cityList.length / perPage)"
        ></v-pagination>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AppModalInsertCity from "./ModalInsert";
import { cityAPI } from "@/modules/city";
import { administrativeDashboardAPI } from "@/modules/administrative-dashboard";
import { cadastroEmLoteAPI } from "./CadastroEmLoteAPI";
import AppStatusCombobox from "./ComboboxStatusRelacionamento.vue";
import { mapActions, mapGetters } from "vuex";
import Vue2Filters from "vue2-filters";
import { AppProjectCombobox } from "@/modules/project";
import ComboboxPacote from "./ComboboxPacote.vue";
import ComboboxUnidadeRegional from "./ComboboxUnidadeRegional.vue";
import ComboboxTemas from "./ComboboxTemas.vue";
import ConsultoresCombobox from "./ComboboxConsultores.vue";
import { userAPI } from "@/modules/user/components/UserAPI";
import {
  statusRelacionamentoEnum,
  statusRelacionamentoSeloEnum,
} from "@/types";
import { DEFAULT_BASE_64_IMG } from "./defaultBase64Img";
import Pagination from "vue-pagination-2";

// import AppModalInsertCutAttendance from '@/modules/attendance/components/ModalInsertCutAttendance'

export default {
  components: {
    AppModalInsertCity,
    // AppModalInsertCutAttendance,
    AppProjectCombobox,
    AppStatusCombobox,
    ComboboxPacote,
    ComboboxUnidadeRegional,
    ComboboxTemas,
    Pagination,
    ConsultoresCombobox,
  },
  mixins: [Vue2Filters.mixin],
  data() {
    return {
      DEFAULT_BASE_64_IMG: DEFAULT_BASE_64_IMG,
      field: "pontos",
      descending: -1,
      cities: [],
      citiesTemas: [],
      consultores: [],
      statusRelacionamentoSeloEnum: statusRelacionamentoSeloEnum,
      municipiosTemas: [],
      filtro: {
        nome: "",
        projetoId: 0,
        consultores: [],
      },
      projects: ["teste", "teste"],
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
      page: 1,
      currentPage: 0,
      perPage: 50,
      cityList: [],
    };
  },
  mounted() {
    this.loadCities();
    this.loadConsultores();
    document.getElementsByClassName("v-content__wrap")[0].style.background =
      "none";
  },
  watch: {
    page: function (old, newValue) {
      this.filterCities();
    },
  },
  computed: {
    ...mapGetters([
      "loading",
      "isAdmin",
      "isSPFesp",
      "isSPFespEspecial",
      "isSPCoordenador",
      "uf",
      "isNA",
      "isFullAdmin",
      "isSala",
      "isAT",
    ]),
  },

  methods: {
    ...mapActions(["setLoading"]),
    getAnaliticoPorIndicador() {
      this.setLoading(true);
      administrativeDashboardAPI
        .getAnaliticoPorIndicador()
        .then((resp) => {
          this.setLoading(false);
          this.$notification.success("Dados Obtidos com Sucesso");
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter dados");
        });
    },
    myCallback(e) {
      console.log("e: ", e);
    },
    cadastrarEmLote() {
      this.setLoading(true);
      cadastroEmLoteAPI
        .cadastrarMunicipios()
        .then((resp) => {
          this.setLoading(false);
          this.$notification.success("Cadastro feito com sucesso");
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao cadastrar municípios");
        });
    },

    loadCities() {
      this.setLoading(true);
      cityAPI
        .list()
        .then((resp) => {
          this.cities = resp.data.map((item) => {
            if (
              item.statusId === statusRelacionamentoEnum.vigente ||
              (this.isSala &&
                item.statusId === statusRelacionamentoSeloEnum.participante)
            ) {
              return item;
            } else {
              return {
                ...item,
                pontos: 0,
                totalMedalhas: 0,
              };
            }
          });
          this.filterCities();
          this.cityList.sort(this.compareDescending);
          this.setLoading(false);
        })
        .catch((resp) => {
          console.log("resp: ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao listar municípios");
        });
    },
    compare(a, b) {
      if (a[this.field] < b[this.field]) {
        return -1;
      }
      if (a[this.field] > b[this.field]) {
        return 1;
      }
      return 0;
    },
    compareDescending(a, b) {
      if (a[this.field] > b[this.field]) {
        return -1;
      }
      if (a[this.field] < b[this.field]) {
        return 1;
      }
      return 0;
    },
    changeOrder(newField) {
      console.log("newField: ", newField);
      if (this.field !== newField) {
        this.descending = -1;
        this.page = 1;
        this.field = newField;
        this.cityList.sort(this.compare);
      } else {
        if (this.descending === 1) {
          this.descending = -1;

          this.cityList.sort(this.compareDescending);
        } else {
          this.descending = 1;
          this.cityList.sort(this.compare);
        }
      }
    },
    setProjects(projects) {
      this.projects = projects;
    },
    loadConsultores() {
      this.setLoading(true);
      userAPI
        .listConsultant()
        .then((resp) => {
          this.consultores = resp.data.filter(
            (item) => item.nome !== "Administrador"
          );
          this.setLoading(false);
        })
        .catch((resp) => {
          console.log("resp: ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao listar municípios");
        });
    },
    loadMunicipiosByTema() {
      if (this.filtro.temaId) {
        this.setLoading(true);
        cityAPI
          .getMunicipioTema(this.filtro.temaId)
          .then((resp) => {
            this.citiesTemas = resp.data;
            this.filterCities();
            this.setLoading(false);
          })
          .catch((resp) => {
            console.log("resp: ", resp);
            this.setLoading(false);
            this.$notification.error("Erro ao listar municípios");
          });
      } else {
        this.filtro = {
          nome: "",
          projetoId: 0,
          consultores: [],
        };
        this.citiesTemas = [];
        this.filterCities();
      }
    },
    filterCities() {
      let cityList = this.filtro.temaId ? this.citiesTemas : this.cities;
      if (this.filtro.nome) {
        cityList = cityList.filter((item) =>
          item.nome.toLowerCase().includes(this.filtro.nome.toLowerCase())
        );
      }

      if (this.filtro.projetoId) {
        cityList = cityList.filter(
          (item) => item.projetoId === this.filtro.projetoId
        );
      }
      if (this.filtro.statusId >= 0 && this.filtro.statusId !== null) {
        cityList = cityList.filter(
          (item) => item.statusId === this.filtro.statusId
        );
      }

      if (this.filtro.pacoteId) {
        cityList = cityList.filter(
          (item) => item.pacoteId === this.filtro.pacoteId
        );
      }

      if (this.filtro.id_unidade_regional) {
        cityList = cityList.filter(
          (item) => item.id_unidade_regional === this.filtro.id_unidade_regional
        );
      }

      if (this.filtro.consultores.length > 0) {
        cityList = cityList.filter((item) =>
          this.filtro.consultores.some(
            (con) => item.consultorId === con.usuarioId
          )
        );
      }
      this.cityList = cityList;
    },
    paginator(cityList) {
      let currentPage = 0;

      if (this.page !== 1) {
        currentPage = this.perPage * (this.page - 1);
      }
      var paginatorCityList = cityList.slice(
        currentPage,
        this.page * this.perPage
      );

      return paginatorCityList;
    },
  },
};
</script>

<style lang="scss">
@import "./style.scss";
</style>
